import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import { type AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import ErpQuotationsListItem from './ErpQuotationsListItem';
import ErpQuotationsDetails from './details/ErpQuotationsDetails';

import buttons from './ErpQuotationsButtons';
// import events from './ErpQuotationsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'erp/quotations/details/:id/:tabId?',
			element: (
				<DetailsPage
					key="erp-quotations/details"
					module="erp_quotations"
					tabs={ErpQuotationsDetails}
					buttons={buttons.details}
				/>
			)
		},
		{
			path: 'erp/quotations/:tabId?',
			element: (
				<ViewPage
					key="erp-quotations/view"
					module="erp_quotations"
					content={{ type: 'list', itemLayout: ErpQuotationsListItem, id: 'erpQuotationsView' }}
					buttons={buttons.view}
					showExportButton={false}
				/>
			)
		}
	]
};

export default routes;
